import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { saveDeepLinkTarget } from '../services/deepLinkTarget';


const PrivateRoute = ({ component: Component, ...rest }) => {
  const checkAuth = rest.isLoggedIn;
  return (
    <Route
      {...rest}
      render={props => {
        if (checkAuth === true) {
          return <Component {...props} {...rest} />;
        }
        saveDeepLinkTarget(props.location);
        return (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;

PrivateRoute.propTypes = {
  location: ReactRouterPropTypes.location,
  history: ReactRouterPropTypes.history,
  component: PropTypes.any,
};